<div
  class="xi-modal__container create-action-item__container"
  *transloco="let t; read: 'create-action-item-dialog-component'"
>
  @if (currentStep === 1) {
    <h2 class="xi-modal__title">{{ titleLabel }}</h2>
    <div class="xi-modal__content create-action-item__item-tab white-box">
      @if (!hasActionPlan) {
        <div class="create-action-item__plan-comment">
          <xi-icon icon="info" color="CX" iconSize="large"></xi-icon>
          <span>{{ t('customize-header') }}</span>
        </div>
      }
      <form autocomplete="off" [formGroup]="form" class="create-action-item__content">
        <div class="col-span-3">
          <label class="kxi-input-label kxi-normal-contrast">{{ t('selected-plan') }}</label>
          <div class="create-action-item__selected-plan-div">
            <app-lex-blue-pill [text]="capitalizeAll(breakdown)"></app-lex-blue-pill>
            <app-lex-blue-pill [text]="capitalizeAll(driverName)"></app-lex-blue-pill>
          </div>
        </div>
        <xi-input-field
          [status]="nameStatus"
          label="{{ t('name') }}"
          formControlName="actionItemName"
          placeholder="{{ t('item-name') }}"
          class="col-span-2"
        ></xi-input-field>
        <div>
          <label class="kxi-input-label kxi-normal-contrast">{{ t('associated-tag') }}</label>
          <app-lex-blue-pill [text]="capitalizeAll(tag)"></app-lex-blue-pill>
        </div>
        <xi-date-picker
          [direction]="3"
          [status]="dueDateStatus"
          [minDate]="actionItemMinDueDate"
          [maxDate]="actionItemMaxDueDate"
          label="{{ t('due-date') }}"
          [dateValue]="form.controls.actionItemDueDate.value"
          formControlName="actionItemDueDate"
          placeholder="{{ t('select-date') }}"
        ></xi-date-picker>
        <xi-input-field
          label="{{ t('assign-to') }}"
          formControlName="actionItemAssignee"
          placeholder="{{ t('assign-placeholder') }}"
          class="col-span-2"
        ></xi-input-field>
        <div class="xi-input-field-wrapper col-span-3">
          <xi-text-area
            label="{{ t('description') }}"
            formControlName="actionItemNote"
            placeholder="{{ t('description-placeholder') }}"
            type="text"
          ></xi-text-area>
        </div>
      </form>
    </div>
    <div class="xi-modal__actions create-action-item__first-step-actions">
      <xi-default-button
        text="{{ t('cancel') }}"
        fill="text"
        (onClick)="onCancel()"
      ></xi-default-button>
      <div class="xi-loader-button-container">
        <xi-default-button
          [text]="buttonLabel"
          [disabled]="form.status !== 'VALID' || isSaving"
          (onClick)="onCreateActionItem()"
        >
        </xi-default-button>
        @if (isSaving) {
          <div class="xi-loader-container__inline-overlay">
            <xi-animation
              [height]="75"
              [width]="75"
              [loop]="true"
              animation="cx_loader"
            ></xi-animation>
          </div>
        }
      </div>
    </div>
  }
  @if (currentStep === 2) {
    <div class="xi-modal__content create-action-item__content-svg">
      <xi-svg svg="celebration"></xi-svg>
    </div>
    <div class="create-action-item__done-title">
      <div>
        <b>{{
          t('successfully-added', {
            actionLabel: actionLabel,
          })
        }}</b>
        <br />
        <span>{{
          t('successfully-added-sub', {
            breakdown: capitalizeAll(breakdown) | truncate: 20,
            driverName: capitalizeAll(driverName) | truncate: 20,
          })
        }}</span>
      </div>
      @if (fromDashboard) {
        <div>
          <b>{{ t('add-more') }}</b>
          <br />
          <span>{{ t('add-more-sub') }}</span>
        </div>
      }
    </div>
    <div class="xi-modal__actions">
      <xi-default-button
        fill="text"
        [text]="fromDashboard ? t('back-to-dashboard') : t('close')"
        (onClick)="onBack()"
      ></xi-default-button>
      @if (fromDashboard) {
        <xi-default-button text="{{ t('add-task') }}" (onClick)="onAddTask()"></xi-default-button>
      }
    </div>
  }
</div>
